import { gql } from 'apollo-angular';

export const SetCompanyDataDocument = gql`
  mutation setCompanyData($input: SetCompanyDataInputGraphql!) {
    setCompanyData(input: $input)
  }
`;
